import * as React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import styled from '@emotion/styled';
import { OptionsFormatDate } from '../../../../../../interfaces/interfaces';
import { InputFilterTableColumnsProps } from '../InputFilterTableColumns/InputFilterTableColumns';
import adaptString from '../../../../../../utils/adapters/stringAdapter';

const StyledInput = styled.input`
  width: 100%;
  margin-left: 0;
`;

const StyledContainerDiv = styled('div')`
  display: flex;
  align-items: center;
  div button {
    padding: 0 0.8rem 0 0;
  }
`;

const InputDataPicker = ({ label, setFilterData, cleanInputs }: InputFilterTableColumnsProps) => {
  const [value, setValue] = React.useState<Date | null>(null);

  const timeConverter = (date: Date | null) => {
    const options: OptionsFormatDate = { year: 'numeric', month: 'short', day: '2-digit' };
    const localDate = date?.toLocaleDateString('en-GB', options).split(' ').reverse().join('/');
    return `${localDate ?? ''}`;
  };

  React.useEffect(() => {
    setValue(null);
    setFilterData({ [label]: '' });
  }, [cleanInputs, label, setFilterData]);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        label={label}
        value={value}
        disableFuture
        clearText="Clear"
        onChange={(newValue) => {
          setValue(newValue);
          setFilterData({ [label]: adaptString(timeConverter(newValue)) });
        }}
        disableMaskedInput
        inputFormat="yyyy/MMM/dd"
        renderInput={({ inputRef, inputProps, InputProps }) => (
          <StyledContainerDiv>
            <StyledInput ref={inputRef} {...inputProps} />
            {InputProps?.endAdornment}
          </StyledContainerDiv>
        )}
      />
    </LocalizationProvider>
  );
};

export default InputDataPicker;
